export default "__VITE_ASSET__fx6yy40K__"